export default {
  props: {
    styleObj: {
      type: Object,
      default() {
        return {};
      }
    },
    pageDescription: {
      type: Boolean,
      default: false
    },
    pageDescriptionConfig: {
      type: Object
    }
  },
  data() {
    return {};
  },
  methods: {
    clickFun() {
      this.$emit('itemClick');
    }
  }
};